import { h } from "preact";

const PGDocumentIcon = ({ className }) => (
  <svg 
  width="12" 
  height="14" 
  viewBox="0 0 12 14" 
  fill="none" 
  className={className}
  xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.99992 7H7.99992M3.99992 9.66667H7.99992M9.33325 13H2.66659C1.93021 13 1.33325 12.403 1.33325 11.6667V2.33333C1.33325 1.59695 1.93021 1 2.66659 1H6.39044C6.56726 1 6.73682 1.07024 6.86185 1.19526L10.4713 4.80474C10.5964 4.92976 10.6666 5.09933 10.6666 5.27614V11.6667C10.6666 12.403 10.0696 13 9.33325 13Z" stroke="#696F7A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default PGDocumentIcon;



// WEBPACK FOOTER //
// ./assets/icons/PGDocumentIcon.js